const SITE = 'Every Frontier'

/**
 * The tab title for a page's `<Head title>`: the page's name, then the site's.
 * A page with no title of its own (the log) is the site. Rails prints the same
 * shape in the layout (PageMetaHelper#page_title), so the two agree.
 */
export function pageTitle(title: string): string {
  return title && title !== SITE ? `${title} · ${SITE}` : SITE
}
